import { Component } from 'react';
import * as language from '../constants/languages';
import Snackbar from '@mui/material/Snackbar';
import '../styles/FeaturedProducts.css'
import Plus from '../assets/svg/plus.svg'
import Minus from '../assets/svg/minus.svg'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import '../styles/FeaturedProducts.css'
import { getProductDetails } from '../services/services';
import { Spinner } from "react-bootstrap"
import { IoIosCart } from "react-icons/io";

export default class FeaturedProductListComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSlideIndex: 0,
            data: [],
            orientation: '',
            snackopen: false,
            message: ''
        };
    }
    async cartQty() {

        try {

            const cart = localStorage.getItem('cartItems')
            if (cart) {
                this.cartItems = JSON.parse(cart);
                for (let i of this.props.data) {
                    const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == i.product.productId);
                    if (elementsIndex != -1) {
                        i.product.cartQty = this.cartItems.customerCartItems[elementsIndex].qty
                    }
                    else {
                        i.product.cartQty = 0
                    }
                }

                for (let i = 0; i < this.props.data.length; i++) {
                    if (this.props.data[i].product.cartQty > 0) {
                        this.setState({
                            ['quantity_' + (this.props.data[i].product.productId)]: this.props.data[i].product.cartQty,
                            ['value_' + (this.props.data[i].product.productId)]: null,
                        })
                    }
                    else {
                        this.setState({
                            ['quantity_' + (this.props.data[i].product.productId)]: 0,
                            ['value_' + (this.props.data[i].product.productId)]: null,
                        })
                        this.props.data[i].product.cartQty = 0
                    }
                }
            }
            else {

                for (let i = 0; i < this.props.data.length; i++) {
                    this.setState({
                        ['quantity_' + (this.props.data[i].product.productId)]: 0,
                        ['value_' + (this.props.data[i].product.productId)]: null,
                    })

                    this.props.data[i].product.cartQty = 0

                    // }
                }
            }
            this.setState({
                data: this.props.data
            })
        }
        catch (e) { console.log(e, 'error') };
    }


    action = (
        <>

            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => this.setState({
                    snackopen: false
                })}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    componentDidMount() {
        this.cartQty()
        this.getCompanyInfo();
        window.addEventListener('productQtyChange', this.qtyChangeEvent)

    }
    componentWillUnmount() {
        window.removeEventListener('productQtyChange', this.qtyChangeEvent);
    }

    qtyChangeEvent = (data) => {
        if (data.token != 0) {
            this.cartQty();
        }
    }

    //get sotre name
    async getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')

        if (value === null || value === undefined) {
            this.companyInfo = null;
            this.setState({
                currencySymbol: ""
            })
        } else {
            this.companyInfo = JSON.parse(value);
            this.setState({
                currencySymbol: this.companyInfo.currencySymbol
            })
        }


    }
    async addToCart(id, productData, index, e) {
        this.setState({
            currentlyFetchingId: (productData.productId),
            isRefetching: (true)
        })
        e.stopPropagation()
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        this.branchId = localStorage.getItem('storeId');

        const currentStock = await this.reFetchProductDetails(productData.productId)
        if (!currentStock && currentStock !== 0) {
            this.setState({
                isRefetching: (false)
            })

            return
        }
        if (productData.isStockAvailable == true) {
            this.cartItemsJson = localStorage.getItem('cartItems');
            if (!this.cartItemsJson) {
                this.cartItems = {
                    customerCartItems: [
                    ],
                    branchId: parseInt(this.branchId),
                    companyId: language.companyidValue
                }
            } else {
                this.cartItems = JSON.parse(this.cartItemsJson);
            }

            const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == productData.productId)
            if (this.branchId == this.cartItems.branchId) {
                var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue);

                if (productData.allowNegativeStock == true || requiredQty <= (currentStock ?? 0)) {
                    if (elementsIndex == -1) {
                        this.cartItems.customerCartItems = [
                            ...this.cartItems.customerCartItems,
                            {
                                product: productData,
                                qty: this.incrementValue,
                                variantId: null
                            }
                        ]
                    } else {
                        this.cartItems.customerCartItems[elementsIndex] = {
                            product: this.cartItems.customerCartItems[elementsIndex].product,
                            qty: this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue,
                            variantId: this.cartItems.customerCartItems[elementsIndex].variantId
                        }
                    }
                    this.setState({
                        ['quantity_' + id]: this.state.data[index].cartQty + this.incrementValue,
                        message: language.itemAddedTocart,
                        snackopen: true
                    })
                    localStorage.setItem('cartItems', JSON.stringify(this.cartItems))
                    const event = new CustomEvent('productQtyChange');
                    window.dispatchEvent(event)
                    this.cartQty()
                } else {
                    this.setState({
                        message: language.cartAddRemove,
                        snackopen: true
                    })
                }

            } else {
                this.setState({
                    message: language.anotherBranch,
                    snackopen: true
                })
            }


        } else {
            this.setState({
                message: language.cartAddRemove,
                snackopen: true
            })
        }
        this.setState({
            isRefetching: false
        })
    }


    reFetchProductDetails = async (product_id) => {
        try {
            const token = localStorage.getItem('access_token');
            const branchId = localStorage.getItem('storeId');
            const productDetails = await getProductDetails(language.companyidValue, product_id, branchId, token);
            if (productDetails.status === 'success') {
                return (productDetails.data.stock)
            }
            else {
                throw new Error
            }
        } catch (error) {
            throw error
        }
    }

    // quantity select
    async quantityPressed(itemIndex, valueAction, productPrice, productId, productData, productListIndex, e) {

        e.stopPropagation()
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        if (this.state['value_' + itemIndex] == null) {

            if (valueAction === 'increment') {
                this.setState({
                    currentlyFetchingId: (productData.productId),
                    isRefetching: (true)
                })
                const currentStock = await this.reFetchProductDetails(productData.productId)
                if (!currentStock && currentStock !== 0) {
                    this.setState({
                        isRefetching: (false)
                    })
                    return
                }
                const qtyToEvaluate = (this.state['quantity_' + (productData.productId)] + this.incrementValue)
                if (productData.allowNegativeStock == true || qtyToEvaluate <= (currentStock ?? 0)) {
                    this.cartAddRemove(productId, 1, itemIndex, productData) //add qny to cart
                }
                this.setState({
                    isRefetching: (false)
                })
            } else {
                if (this.state['quantity_' + itemIndex] != this.incrementValue) {

                    this.cartAddRemove(productId, 0, itemIndex, productData) //reduce qny to cart
                } else {
                    this.removeItem(productId, productData, productListIndex);
                }
            }
        }

    }
    // remove the product
    async removeItem(id, productData, index) {
        let cart = localStorage.getItem('cartItems');
        let cartItems = JSON.parse(cart);
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == id);
        cartItems.customerCartItems.splice(elementsIndex, 1);
        localStorage.setItem('cartItems', JSON.stringify(cartItems))

        if (cartItems.customerCartItems.length == 0) {
            localStorage.removeItem('cartItems')
        }
        this.cartQty();
        this.setState({
            message: language.removedFromCart,
            snackopen: true
        })

        const event = new CustomEvent('productQtyChange');;
        window.dispatchEvent(event)

    }

    // add/remove cart
    async cartAddRemove(id, action, itemIndex, productData) {
        this.branchId = localStorage.getItem('storeId');
        this.cartItemsJson = localStorage.getItem('cartItems');

        if (!this.cartItemsJson) {
            this.cartItems = {
                customerCartItems: [
                ],
                branchId: parseInt(this.branchId),
                companyId: language.companyidValue
            }
        } else {
            this.cartItems = JSON.parse(this.cartItemsJson);
        }
        if (productData.incrementValue == null) {
            this.incrementValue = 1
        } else {
            this.incrementValue = productData.incrementValue
        }
        if (action == 1) { //add to cart
            if (productData.isStockAvailable == true) {
                const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == productData.productId)
                if (this.branchId == this.cartItems.branchId) {
                    var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue);
                    productData.allowNegativeStock = true
                    if (productData.allowNegativeStock == true || requiredQty <= (productData.stock ?? 0)) {
                        if (elementsIndex == -1) {
                            this.cartItems.customerCartItems = [
                                ...this.cartItems.customerCartItems,
                                {
                                    product: productData,
                                    qty: this.incrementValue,
                                    variantId: null
                                }
                            ]
                        } else {
                            this.cartItems.customerCartItems[elementsIndex] = {
                                product: this.cartItems.customerCartItems[elementsIndex].product,
                                qty: this.cartItems.customerCartItems[elementsIndex].qty + this.incrementValue,
                                variantId: this.cartItems.customerCartItems[elementsIndex].variantId
                            }
                        }
                        // await Asyncstorage.setStringItem('cartItems', JSON.stringify(cartItems));
                        localStorage.setItem('cartItems', JSON.stringify(this.cartItems))
                        const event = new CustomEvent('productQtyChange', { token: 0 });;
                        window.dispatchEvent(event)
                        this.setState({
                            ['quantity_' + itemIndex]: this.state['quantity_' + itemIndex] + this.incrementValue,
                        })
                    } else {
                        this.setState({
                            message: language.cartAddRemove,
                            snackopen: true
                        })
                    }
                } else {
                    this.setState({
                        message: language.anotherBranch,
                        snackopen: true
                    })
                }
            } else {
                this.setState({
                    message: language.cartAddRemove,
                    snackopen: true
                })
            }
        } else { //reduce from cart
            if (this.branchId == this.cartItems.branchId) {
                const elementsIndex = this.cartItems.customerCartItems.findIndex(element => element.product.productId == id);
                if (elementsIndex > -1) {
                    var requiredQty = elementsIndex == -1 ? this.incrementValue : (this.cartItems.customerCartItems[elementsIndex].qty - this.incrementValue);
                    this.cartItems.customerCartItems[elementsIndex] = {
                        product: this.cartItems.customerCartItems[elementsIndex].product,
                        qty: (requiredQty < 0 ? 0 : requiredQty),
                        variantId: this.cartItems.customerCartItems[elementsIndex].variantId,
                    }
                    // await Asyncstorage.setStringItem('cartItems', JSON.stringify(cartItems));
                    localStorage.setItem('cartItems', JSON.stringify(this.cartItems))
                    const event = new CustomEvent('productQtyChange', { token: 0 });;
                    window.dispatchEvent(event)
                    // Toast.show(language.itemReducedFromCart);
                    this.setState({
                        ['quantity_' + itemIndex]: this.state['quantity_' + itemIndex] - this.incrementValue,
                    })
                }
            } else {
                this.setState({
                    message: language.anotherBranch,
                    snackopen: true
                })
            }
        }
    }

    onSnackClose = () => {
        this.setState({
            snackopen: false
        })
    }
    gotoDetails = (item) => {
        this.props.navigate(`/Productdetails/${item.productId}`)
    }

    render() {
        return (

            <div className='grid-container'>
                <div className='featured-product-container'>
                    <div className='featured-product'>
                        {
                            this.state.data?.map((item, i) => (
                                <div key={i} className='grid-item-product' onClick={() => this.gotoDetails(item.product)}>

                                    {/* ── Offer badge ── */}
                                    {
                                        (() => {
                                            const showBadge = item.product.oRate == null
                                                ? item.product.sRate < (item.product.mrp == null ? item.product.sRate : item.product.mrp)
                                                : item.product.oRate < (item.product.mrp == null ? item.product.sRate : item.product.mrp);
                                            return showBadge
                                                ? <p className='offerTag'>{item.product.savedPercentage}% OFF</p>
                                                : null;
                                        })()
                                    }

                                    {/* ── Product image ── */}
                                    <div className='card-image-wrap'>
                                        <img
                                            src={item.product.tblProductImages ? item.product.tblProductImages[0].image : ''}
                                            className='image-featured'
                                            alt={item.product.productName}
                                        />
                                    </div>

                                    {/* ── Card body ── */}
                                    <div className='card-body'>

                                        {/* Name */}
                                        <p className='card-product-name'>{item.product.productName}</p>
                                        {item.product.regionalLanguage && item.product.regionalLanguage !== ""
                                            && <p className='card-regional'>{item.product.regionalLanguage}</p>}

                                        {/* Stock + GST inline */}
                                        <div className='card-stock-row'>
                                            {item.product.isStockAvailable === false
                                                ? <p className='card-stock-out'>{language.outStockLabel}</p>
                                                : <p className='card-stock-in'>{language.inStockLabel}</p>
                                            }
                                            <p className='card-gst-label'>Excluding 18% GST</p>
                                        </div>

                                        {/* Price */}
                                        <div className='card-price-section'>
                                            {(() => {
                                                const effectivePrice = item.product.oRate != null ? item.product.oRate : item.product.sRate;
                                                const listPrice = item.product.mrp != null ? item.product.mrp : item.product.sRate;
                                                const hasDiscount = effectivePrice < listPrice;
                                                return (
                                                    <>
                                                        <div className='card-price-row'>
                                                            {hasDiscount && (
                                                                <p className='card-mrp'>
                                                                    {this.state.currencySymbol} {(listPrice * (item.product.incrementValue || 1)).toFixed(2)}
                                                                </p>
                                                            )}
                                                            <p className='card-selling-price'>
                                                                {this.state.currencySymbol} {(effectivePrice * (item.product.incrementValue || 1)).toFixed(2)}
                                                            </p>
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        <div className='card-divider' />

                                        {/* ── Cart action ── */}
                                        {language.type === 0 && (
                                            <div className='card-action' onClick={e => e.stopPropagation()}>
                                                {item.product.cartQty > 0 && item.product.isStockAvailable !== false ? (
                                                    <div className='quantityWrapperFeaturedProducts'>
                                                        <div onClick={(e) => this.quantityPressed(item.product.productId, 'decrement', item.product.sRate, item.product.productId, item.product, (i + 1), e)}>
                                                            <img src={Minus} alt='-' />
                                                        </div>
                                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {this.state.isRefetching && this.state.currentlyFetchingId === item.product.productId
                                                                ? <Spinner animation="border" size='sm' style={{ width: 14, height: 14 }} />
                                                                : <p style={{ fontFamily: 'Poppins-Regular', margin: 0, fontSize: 13, fontWeight: 600 }}>
                                                                    {this.state['quantity_' + item.product.productId]}
                                                                    {item.product.unit && item.product.unit !== '-- None --' ? ` ${item.product.unit}` : ''}
                                                                  </p>
                                                            }
                                                        </div>
                                                        <div onClick={(e) => this.quantityPressed(item.product.productId, 'increment', item.product.sRate, item.product.productId, item.product, (i + 1), e)}>
                                                            <img src={Plus} alt='+' />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='cartWrapper' onClick={(e) => this.addToCart(item.productId, item.product, i, e)}>
                                                        {this.state.isRefetching && this.state.currentlyFetchingId === item.product.productId
                                                            ? <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
                                                                <Spinner animation="border" size='sm' style={{ width: 18, height: 18 }} />
                                                              </div>
                                                            : <p className='cart-style'>
                                                                <IoIosCart style={{ fontSize: 15 }} /> {language.addToCartLabel}
                                                              </p>
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <Snackbar
                    open={this.state.snackopen}
                    autoHideDuration={2000}
                    onClose={this.onSnackClose}
                    message={this.state.message}
                    action={this.action}
                    ContentProps={{
                        style: { backgroundColor: '#388E3C' } // ✅ Green
                    }}
                />
            </div>
        )
    }
}

